import DatePicker from 'components/form/DatePicker';
import DateTimePicker from 'components/form/DateTimePicker';
import TextInput from 'components/form/TextInput';
import TimePicker from 'components/form/TimePicker';
import moment from 'moment';
import React from 'react';
// Pre-Conference Webinar Announcement
const SixteenStepOfFollowUps = ({ props, isEdit, suggestionData }) => {
  // const { handleChange, values } = props;
  const { values, errors, touched, handleChange, handleBlur } = props;

  const {
    client_name,
    speaker_name,
    webinar_date_time,
    relevent_field_topic,
    conference_name,
    registration_link,
  } = values;
  return (
    <>
      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Recipient's Name
        </div>
        <div className="col-lg-6">
          <TextInput
            id="client_name"
            onChange={handleChange}
            value={client_name}
            disabled={!isEdit}
            onBlur={handleBlur}
            error={touched.client_name && errors.client_name}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Speaker's Name
        </div>
        <div className="col-lg-6">
          <TextInput
            id="speaker_name"
            onChange={handleChange}
            value={speaker_name}
            disabled={!isEdit}
            suggestions={suggestionData?.speaker_name}
            onBlur={handleBlur}
            error={touched.speaker_name && errors.speaker_name}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Webinar Date And Time
        </div>
        <div className="col-lg-6">
          <DateTimePicker
            id="webinar_date_time"
            onChange={handleChange}
            value={webinar_date_time}
            disabled={!isEdit}
            error={errors.webinar_date_time}
          />
        </div>
      </div>

      {/* <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Webinar Time
        </div>
        <div className="col-lg-6">
          <TimePicker
            // placeholder="Enter Session Time"
            id="webinar_time"
            onChange={handleChange}
            value={webinar_time}
          />
        </div>
      </div> */}

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Relevant Field/Topic
        </div>
        <div className="col-lg-6">
          <TextInput
            id="relevent_field_topic"
            onChange={handleChange}
            value={relevent_field_topic}
            disabled={!isEdit}
            suggestions={suggestionData?.relevent_field_topic}
            onBlur={handleBlur}
            error={touched.relevent_field_topic && errors.relevent_field_topic}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Conference Name
        </div>
        <div className="col-lg-6">
          <TextInput
            id="conference_name"
            onChange={handleChange}
            value={conference_name}
            disabled={!isEdit}
            suggestions={suggestionData?.conference_name}
            onBlur={handleBlur}
            error={touched.conference_name && errors.conference_name}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Registration Link
        </div>
        <div className="col-lg-6">
          <TextInput
            id="registration_link"
            onChange={handleChange}
            value={registration_link}
            disabled={!isEdit}
            suggestions={suggestionData?.registration_link}
            onBlur={handleBlur}
            error={touched.registration_link && errors.registration_link}
          />
        </div>
      </div>
    </>
  );
};

export default SixteenStepOfFollowUps;
